<div class="panel-body">
    <div x-table-gauge="" x-data="data" x-options="config" style="height: 100%;"></div>
</div>